import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable, reaction} from 'mobx'
import {isValidPhoneNumber} from 'libphonenumber-js'
import {post} from '../common/requester'

export default class Team extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      id: observable,
      name: observable,
      company_id: observable,
      sport_id: observable,
      sport: observable,
      members: observable,
      was_validated: observable,
      is_valid: computed,
      validate: action,
      get_company_sports: action,
      setMembers: action,
      sports: observable,
    })
    reaction(() => this.company_id, (new_id, old_id) => {
      this.get_company_sports(new_id);
    })
  }
  
  id = 0;
  name = '';
  company_id = null;
  sport_id = null;
  was_validated = false;
  sport = {};
  members = [];
  sports = [];
  
  get is_valid() {
    return this.name && this.company_id && this.sport_id;
  }
  
  validate = () => {
    this.was_validated = true;
    return this.is_valid;
  }
  async get_company_sports(company_id) {
    this.setProperty('sport_id', null)
    const res = await post('company_sports', {company_id})
        .catch((err) => console.error('--company sports get error', err))
      if (res) {
        this.sports = res.sports;
        if (this.sports.length === 1) {
          this.setProperty('sport_id', this.sports[0].id)
        }
        return Promise.resolve(this.sports)
      } else {
        return Promise.reject()
      }
  }
  
  setMembers = (members) => {
    this.members = members;
  }
}